import { createGlobalStyle } from "styled-components";
import { background } from "./colors";

import wave from "../../images/wave.png";
import bg from "../../images/bg.png";


export const GlobalStyle = createGlobalStyle`

button {
  background-color: #fff;
  border-radius: 4px;
  appearance: none;
  outline: none;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.15);
  --button-glow-start: rgba(76,206,248,0.2);
  --button-glow-end: rgba(182,255,175,0.4);
  --button-glow: #fff;
  transition: transform ease-out .2s;

  &:hover {
    transform: scale(1.03);
  }

  &:active {
    background-color: #ddd;
    transform: scale(0.98);
  }

  &:hover::before {
    opacity: 1;
  }

  &::before {
    border-radius: inherit;
    content: "";
    height: 100%;
    left: 0px;
    opacity: 0;
    position: absolute; // results in a z-stacking before&after
    top: 0px;
    transition: opacity 300ms;
    width: 100%;
  }

  // this is the background glow effect, will be triggered only by the hover effect on the card element

  &::before {
    background: radial-gradient(
      500px circle at var(--mouse-x) var(--mouse-y),
      var(--button-glow),
      transparent 10%
    );
    z-index: 1;
  }
}

.animation-text {
  animation: bg-animation 4s linear infinite;
  background: linear-gradient(90deg, #7B5CF4 0%, #7B5CF4 16%, #D095FF 23%, #6E28EA 30%, #AC28EA 60% ,#7B5CF4 100%);
  background-size: 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
  z-index: 2;
}

@keyframes bg-animation {
  from {
    background-position: 0% center;
  }
  
  to {
    background-position: -200% center;
  }
}

footer {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 1rem;

  a {
    display: flex;
    justify-content: center;
    text-decoration: none;
    z-index: 4;
  }

  a div {
    font-family: "Inter";
    color: #0E0620;
    font-size: 16px;
    margin-left: 8px;
    z-index: 3;
  }
}

  body {
    font-family: "Inter";
    font-weight: 300;
    background-color: ${background};
    position: relative;
    margin: 0px;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  };

  // body::before {
  //   background-image: url(${wave});
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   background-position: center;
  //   opacity: 0.3;
  //   content: "";
  //   display: block;
  //   position: absolute;
  //   height: 100%;
  //   width: 100%;
  // }

  body::after {
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    opacity: 0.1;
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
`;
